import React, { useState } from "react";
import { ArrowRight, Crown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import WorkoutDetail from "./WorkoutDetail";
import { WORKOUT_DATA } from './WorkoutData';

const WorkoutSection = () => {
  const [selectedWorkout, setSelectedWorkout] = useState(null);

  return (
    <div className="relative min-h-screen bg-gray-50 p-4">
      {/* Detail Overlay - Renders only when a workout is selected to save memory */}
      <AnimatePresence>
        {selectedWorkout && (
          <WorkoutDetail 
            workout={selectedWorkout} 
            onBack={() => setSelectedWorkout(null)} 
          />
        )}
      </AnimatePresence>

      <div className="max-w-md mx-auto space-y-6 pt-4">
        <div className="space-y-4">
          {WORKOUT_DATA.map((item) => (
            <motion.div
              key={item.id}
              onClick={() => setSelectedWorkout(item)}
              whileTap={{ scale: 0.97 }}
              className="bg-white p-4 rounded-[32px] border border-gray-100 flex justify-between items-center cursor-pointer shadow-sm relative overflow-hidden group hover:shadow-xl transition-all duration-300"
            >
              {item.premium && (
                <div className="absolute top-0 right-0 bg-amber-400 p-2 rounded-bl-2xl z-10">
                   <Crown size={14} className="text-white" fill="white" />
                </div>
              )}
              
              <div className="flex items-center gap-5">
                {/* Image Compression: w=200 & q=80 reduces file size significantly */}
                <img 
                  src={`${item.image}&auto=format&q=80&w=200`} 
                  alt={item.name} 
                  className="w-20 h-20 rounded-3xl object-cover shadow-md" 
                />
                <div>
                  <h3 className="font-black text-xl text-gray-900 uppercase leading-none mb-2">
                    {item.name}
                  </h3>
                  <div className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">
                      {item.exercises_count} Exercises
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-900 text-white p-3 rounded-2xl group-hover:bg-blue-600 transition-colors shadow-lg">
                <ArrowRight size={20} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkoutSection;